/**
 * A respondent's own option ("add your own option") is saved under its option id, so its value is a UUID.
 * Standard choices are saved as their code or text, never a UUID.
 */
const OWN_OPTION_VALUE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isOwnOptionValue(value: unknown): value is string {
    return typeof value === "string" && OWN_OPTION_VALUE.test(value);
}
